<form data-cy="multiselect-users__users-form-form" [formGroup]="usersForm">
    <mat-form-field appearance="outline" class="modal-newlog-users_multiselect full-width">
      <mat-label>{{ placeholder }}</mat-label>
        <input data-cy="multiselect-users__text-input" #mySelect matInput [matAutocomplete]="auto" [matChipInputFor]="usersList" (matChipInputTokenEnd)="addUser($event)" [disabled]="disabled" formControlName="text"  class="add-users"/>
        <mat-chip-grid #usersList>
            <mat-chip-row *ngFor="let user of selectedUsers" [removable]="!disabled" (removed)="removeUser(user, true)">
                {{user.name}}
                <span *ngIf="chipDisabler.length === 0">
                    <mat-icon matChipRemove *ngIf="!disabled">cancel</mat-icon>
                </span>
                <span *ngFor="let chip of chipDisabler">
                    <mat-icon matChipRemove *ngIf="!disabled && chip.name !== user.name">cancel</mat-icon>
                </span>
            </mat-chip-row>
        </mat-chip-grid>
        <mat-autocomplete #auto="matAutocomplete">
            <ng-container *ngIf="!multipleUsers">
                <mat-option class="user-option" *ngFor="let user of filteredUsers; let index = index" [value]="user" [ngClass]="{'disable_enitiy': user.is_permission}" [class]="'add-users-list-item-' + ( index+1 )" (click)="addUser(user, $event)" (mousedown)="$event.preventDefault()">
                  {{ user.name }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="multipleUsers">
                <mat-option class="user-option" *ngFor="let user of filteredUsers; let index = index" [value]="user" [ngClass]="{'disable_enitiy': user.is_permission}" [class]="'add-users-list-item-' + ( index+1 )" (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation();">
                        <div data-cy="multiselect-users__page" class="user-check" (click)="addUser(user, $event)">
                            <mat-checkbox data-cy="multiselect-users__checkbox" [checked]="isUserSelected(user)">{{ user.name }}</mat-checkbox> 
                        </div>
                    </mat-option>
            </ng-container>
        </mat-autocomplete>
    </mat-form-field>
</form>
